<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="联系人" name="delivery_name"></c-form-item>
					<c-form-item type="input" label="联系方式" name="delivery_mobile"></c-form-item>
					<c-form-item type="input" label="地址" name="delivery_address"></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="state"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_delivery_address_edit"  @click="add">新增发货地址</c-button>
			</m-operate>
			
			<c-table ref="table" code="">
				<c-table-column
					label="联系人"
					name="delivery_name"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:red">{{stateName[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="联系方式"
					name="delivery_mobile"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="地址"
					name="delivery_address"
					width="300"
				>
					<template v-slot="{data}">
                        <span v-if="data.delivery_province_name">{{data.delivery_province_name}},</span>
                        <span v-if="data.delivery_city_name">{{data.delivery_city_name}},</span>
                        <span v-if="data.delivery_county_name">{{data.delivery_county_name}},</span>
                        <span v-if="data.delivery_address">{{data.delivery_address}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="是否默认"
					name="is_default"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.is_default == 1" style="color:#999">{{defaultName[data.is_default]}}</span>
						<span v-if="data.is_default == 2" style="color:green">{{defaultName[data.is_default]}}</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="所属商家"
					name="stationed_name"
					width="160"
				></c-table-column> -->
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button power="b_delivery_address_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_delivery_address_edit" v-if="data.is_default == 1" @click="del(data)">删除</c-table-button>
						<c-table-button power="b_delivery_address_edit" v-if="data.state == 2 && data.is_default == 1" @click="setDefault(data)">设为默认</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="uEdit" :title="editState ? '编辑发货地址' : '新增发货地址'" width="600" @resolve="submit">
			<c-form ref="uForm">
				<c-form-item type="input" label="联系人" name="delivery_name" required></c-form-item>
				<c-form-item type="input" label="联系方式" name="delivery_mobile" required></c-form-item>
				<c-form-item type="region" label="发货地" province-name="delivery_province_id" city-name="delivery_city_id" county-name="delivery_county_id"  required></c-form-item>
				<c-form-item type="input" label="" name="delivery_address" required></c-form-item>
				<c-form-item type="radio" label="是否启用" name="state" :options="state" required></c-form-item>
				<c-form-item type="radio" label="是否默认" name="is_default" :options="is_default"  v-show="!editState" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_task_center_list',
		
		data() {
			return {
				stateName: {
					1: '禁用',
					2: '启用'
				},
				defaultName: {
					1: '否',
					2: '是'
				},
				state: [{
						name: '禁用',
						value: "1"
					},{
						name: '启用',
						value: "2"
					}
				],
				is_default: [{
						name: '否',
						value: "1"
					},{
						name: '是',
						value: "2"
					}
				],
				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/delivery_address/list',
					data
				});
			},
			add(stop) {
				this.editState = false;
				this.$refs.uForm.clear();
				this.$refs.uEdit.open();
			},
			edit(val) {
				this.editState = true;
				this.$refs.uForm.set(val);
				this.$refs.uEdit.open();
			},
			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.delivery_address+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/delivery_address/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			setDefault(val) {
				this.$confirm({
					text: '确定要将【'+val.delivery_address+'】设置为默认发货地址吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/delivery_address/default',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '设置成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			submit(stop) {
				stop();
				let submitUrl = '/delivery_address/add';
				if(this.editState){
					submitUrl = '/delivery_address/edit';
				}
				this.$refs.uForm.submit({
					url: submitUrl,
					rule: {
					  delivery_name: '请填写联系人',
					  delivery_mobile: '请填写联系方式',
                      delivery_province_id: '请选择发货地所在省份',
					  delivery_city_id: '请选择发货地所在城市',
                      delivery_county_id: '请选择发货地所在区县',
					  delivery_address: '请填写发货地址详细地址',
					  state: '请选择是否启用',
					  is_default: '请选择是否默认'
					},
					dataFormatter: data => {
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.uEdit.close();
					},
				});
			}
		}
	}
</script>